import(/* webpackMode: "eager" */ "/home/interim/frontend/app/solutions/for-applicants/page.tsx");
